"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onInitialClientRender = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createOptions2 = _interopRequireDefault(require("./create-options"));

var onInitialClientRender =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(_, pluginOptions) {
    var _createOptions, firstInputDelay, useLogging, useGoogleAnalytics;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _createOptions = (0, _createOptions2["default"])(pluginOptions), firstInputDelay = _createOptions.firstInputDelay, useLogging = _createOptions.useLogging, useGoogleAnalytics = _createOptions.useGoogleAnalytics;

            if (firstInputDelay && window.perfMetrics) {
              window.perfMetrics.onFirstInputDelay(function (delay, event) {
                if (useLogging) {
                  console.group('first-input-delay');
                  console.log('First Input Delay:', Math.round(delay));
                  console.log('Event details', event);
                  console.groupEnd();
                }

                if (useGoogleAnalytics && window.ga) {
                  window.ga('send', 'event', {
                    eventCategory: 'Performance Metrics',
                    eventAction: 'first-input-delay',
                    eventLabel: event.type,
                    eventValue: Math.round(delay),
                    nonInteraction: true
                  });
                }
              });
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onInitialClientRender(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.onInitialClientRender = onInitialClientRender;